import { call, put, takeLatest } from "redux-saga/effects";
import { studentAPI } from "../../../services/student/index"
import { submitApplication, SUBMIT_APPLICATION} from "../../actions/student.action"

function* handleSubmitApplication(action) {
  try {
    const { data : resData} = yield call(studentAPI.submitApplication, action.payload);
    //extract the data here     
    yield put(submitApplication.success({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(submitApplication.failure({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  }
}

function* submitApplicationSaga() {
  yield takeLatest(SUBMIT_APPLICATION.REQUEST, handleSubmitApplication);
}

export default submitApplicationSaga;
